import('./bootstrap');

// import.meta.hot is undefined under vitest, so no explicit MODE !== 'test' guard needed
if (import.meta.hot) {
  import.meta.hot.accept();
}
